export default __webpack_public_path__ + "static/media/QoS-2.ebde498f.png";